<template>
    <div class="auto-refresh">
        <button @click="refresh" :disabled="disabled" title="Refresh">
            <font-awesome-icon icon="rotate" :spin="disabled" fixed-width></font-awesome-icon>
        </button>
        <button v-if="!isPolling" title="Enable auto-refresh" @click="togglePolling()">
             <font-awesome-layers fixed-width>
                <font-awesome-icon icon="rotate"></font-awesome-icon>
                <font-awesome-layers-text value="Auto" transform="shrink-8 down-10"></font-awesome-layers-text>
            </font-awesome-layers>
        </button>
        <button v-else class="auto-refresh-active" title="Disable auto-refresh" @click="togglePolling()">
             <font-awesome-layers>
                <font-awesome-icon icon="rotate" transform="up-5 left-7 shrink-6" :shake="pollSecondsRemaining < 4"></font-awesome-icon>
                <font-awesome-layers-text :value="pollSecondsRemaining" transform="down-6 right-5 shrink-2" />
             </font-awesome-layers>
        </button>
    </div>
</template>
<script>

export default {
    name: 'AutoRefresh',
    props: {
        disabled: { type: Boolean, default: false},
        pollInterval: { type: Number, default: 0},
        pollTimeoutInterval: { type: Number, default: 30 * 60 },
    },
    data() {
        return {
            pollSecondsRemaining: 0,
            pollTimeoutId: null,
            pollTimeoutTimeoutId: null,
        }
    },
    methods: {
        async refresh() {
            this.$emit('refresh');
        },
        async poll() {
            this.pollSecondsRemaining--;
            if (this.pollSecondsRemaining === 0) {
                await this.refresh();
                this.pollSecondsRemaining = this.pollInterval;
            }
            this.pollTimeoutId = window.setTimeout(this.poll, 1000);
        },
        togglePolling() {
            if (this.isPolling) {
                this.stopPolling();
            }
            else {
                this.startPolling();
            }
        },
        startPolling() {
            if (this.isPolling) return;
            if (this.pollInterval === 0) return;

            this.pollSecondsRemaining = this.pollInterval;
            this.pollTimeoutId = window.setTimeout(this.poll, 1000);
            this.pollTimeoutTimeoutId = window.setTimeout(this.stopPolling, this.pollTimeoutInterval * 1000);
        },
        stopPolling() {
            this.pollSecondsRemaining = 0;
            window.clearTimeout(this.pollTimeoutId);
            this.pollTimeoutId = null;
            window.clearTimeout(this.pollTimeoutTimeoutId);
            this.pollTimeoutTimeoutId = null;
        },
    },
    computed: {
        isPolling() {
            return this.pollTimeoutId !== null;
        },
    },
}
</script>
<style scoped>
.auto-refresh {
    display: flex;
    align-items: end;
    text-wrap: nowrap;
}
.auto-refresh button {
    border: 1px solid rgb(118, 118, 118, 0.75);
    border-right: none;
    text-wrap: nowrap;
}
.auto-refresh button:focus {
    outline: rgba(102, 179, 227, 0.75) auto 1px !important;
    outline-offset: 0px;
    z-index: 99;
}
.auto-refresh button:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
}
.auto-refresh button:last-of-type {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-right: 1px solid rgb(118, 118, 118);
}
.auto-refresh-active {
    filter: brightness(80%);
}
</style>
